import { Countries } from '../../../utils/countries'
import { Network } from '../../../utils/network'
import { Formatter } from '../formatter'

import urls from './urls.json'

async function resolvePhoneNumber(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  return parsedResponse
}

async function sendRequest(data) {
  let url = urls.getPhoneDetails
  let phoneNumber = `${data.phoneNumber || ''}`
  console.log(data)
  if (data.countryCode) {
    const country = Countries.find(data.countryCode)
    if (country && !phoneNumber.startsWith(country.phonePrefix)) {
      phoneNumber = `${country.phonePrefix}${phoneNumber}`
    }
  }
  url += phoneNumber
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const rawData = response.response.data

    return {
      success: rawData.isValid,
      decoded: {
        id: rawData.id,
        carrier: rawData.carrier,
        isValid: rawData.isValid,
        countryCode: rawData.countryCode,
        nationalNumber: rawData.nationalNumber,
        countryCallingCode: rawData.countryCallingCode,
        internationalNumber: `${rawData.internationalNumber}`.replace(/[^\d]/g,''),
      },
    }
  }
  if (response === null || response.status.code === 401) {
    return {
      success: false,
    }
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: 'error',
      networkError: true,
    }
  }
  return {
    success: false,
    message: 'error',
  }
}
export { resolvePhoneNumber }
